export default {
  MEMBER: 'member',
  PUBLIC: 'public'
}
